<template>
  <!-- 录音识别配置 -->
  <section class="viewContainer">
    <!-- 搜索/查询 -->
    <div class="main_container">
      <div class="fuji" @click="show3 = !show3">
        <div class="goodslist1">
          <span style="margin-left:20px;margin-top:5px">搜索/查询</span>
          <span class="divReset" @click.stop="fnReset"><img src="../../assets/img/Reset.png" alt /></span>
          <!-- <span class="goods_red" /> -->
        </div>
        <div style="position: absolute;right:0;top:-10px" class="sanjiao" />
      </div>
      <!-- 顶部搜索框 -->
      <el-collapse-transition>
        <div v-show="show3">
          <el-form class="findform">
            <el-form-item label="关键字：" style="display:flex;width:25%">
              <el-input v-model="jsName" placeholder="请输入关键字" style="width:90%;" />
            </el-form-item>
            <el-form-item label="业务类型：" style="display:flex;width:25%">
              <el-select v-model="caozuo" placeholder="请选择" style="width:90%">
                <el-option :label="item.label" :value="item.Id" v-for="(item, index) in caozuoarr" :key="item.Id" />
              </el-select>
            </el-form-item>
            <el-form-item label="配置类型：" style="display:flex;width:25%">
              <el-select v-model="configtype" placeholder="请选择" style="width:90%">
                <el-option :label="item.label" :value="item.Id" v-for="(item, index) in configtypeArr" :key="item.Id" />
              </el-select>
            </el-form-item>
            <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
          </el-form>
        </div>
      </el-collapse-transition>
    </div>
    <!--列表-->
    <div class="main_container">
      <section class="model_section">
        <p class="model_top_title">{{ addeditsee }}</p>
        <el-button type="danger" @click="addOrEditBrand()" style="float: right;margin: 5px 10px 0 0;">新增</el-button>
      </section>
      <div class="table_container">
        <el-table :data="dataList" stripe border>
          <el-table-column label="序号" align="center" width="50" key="1">
            <template scope="scope"> <span>{{ scope.$index + 1 }}</span> </template>
          </el-table-column>
          <el-table-column label="业务类型名称" align="center">
            <template scope="scope">
              <span :title="scope.row.businessType" :label="scope.row.businesstypename">
                {{ scope.row.businesstypename }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="配置类型名称" align="center">
            <template scope="scope">
              <span :title="scope.row.configtypename" :label="scope.row.score">{{ scope.row.configtypename }}</span>
            </template>
          </el-table-column>
          <el-table-column label="关键字" align="center">
            <template scope="scope">
              <span :title="scope.row.keyword" :label="scope.row.keyword">{{ scope.row.keyword }}</span>
            </template>
          </el-table-column>
          <el-table-column label="权重分值" align="center">
            <template scope="scope">
              <span :title="scope.row.level" :label="scope.row.score">{{ scope.row.score }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作人" align="center">
            <template scope="scope">
              <span :title="scope.row.operator" :label="scope.row.operatorname">{{ scope.row.operatorname }}</span>
            </template>
          </el-table-column>
          <el-table-column label="最后操作时间" align="center">
            <template scope="scope">
              <span :title="scope.row.lastOperTime" :label="scope.row.lasttime">{{ scope.row.lasttime }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" width="200" align="center">
            <template scope="scope">
              <span class="handle" @click="addOrEditBrand(scope.row)">
                <i class="el-icon-edit-outline"></i> 编辑
              </span>
              <span class="handle" @click="deleteBrand(scope.row)">
                <i class="el-icon-delete"></i> 删除
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :current-page="pageIndex"
          :page-size="10" :total="total" style="margin:10px 0;float:right" />
      </div>
    </div>

    <!-- 新增/编辑品牌管理-弹框 -->
    <el-dialog :title="addeditsee" :center="true" class="add_order_cancle" width="40%" :visible.sync="isToExamine">
      <el-form ref="form" :model="form" label-width="100px">
        <el-form-item label="业务类型：" prop="businessType" style="width:80%;">
          <el-select v-model="form.businessType" placeholder="请选择" :disabled="addeditsee === '编辑'">
            <el-option :label="item.label" :value="item.Id" v-for="(item, index) in caozuoarr.filter(item => item.Id !== -1)" :key="index" />
          </el-select>
        </el-form-item>
        <el-form-item label="配置类型：" prop="configType" style="width:80%;">
          <el-select v-model="form.configType" placeholder="请选择" :disabled="addeditsee === '编辑'" @change="handleConfigTypeChange">
            <el-option :label="item.label" :value="item.Id"
              v-for="(item, index) in configtypeArr.filter(item => item.Id !== 0)" :key="item.Id" />
          </el-select>
        </el-form-item>
        <el-form-item label="校验值：" prop="checkValue" style="width:80%;"
          v-if="form.configType === 1 || form.configType === 2">
          <el-input v-model="form.checkValue" placeholder="请输入校验值（数字）" maxlength="3" show-word-limit type="number" min="0" @input="handleLevelInputa"/>
        </el-form-item>
        <el-form-item label="关键字：" prop="keyword" style="width:80%;">
          <el-input v-model="form.keyword" placeholder="请输入关键字" maxlength="50" show-word-limit
            :disabled="form.configType !== 5"/>
        </el-form-item>
        <el-form-item label="权重分值：" prop="level" style="width:80%;">
          <el-input v-model="form.level" placeholder="请输入0-100的数字" maxlength="3" show-word-limit
            @input="handleLevelInput" type="number" />
        </el-form-item>
        <el-form-item label="备注：" prop="remark" style="width:80%;">
          <el-input v-model="form.remark" placeholder="请输入备注" maxlength="200" show-word-limit type="textarea"
            :rows="3" />
        </el-form-item>
      </el-form>
      <!-- 弹框按钮 确定/取消 -->
      <div style="padding-left:0;text-align:center">
        <button type="button" @click="isToExamine = false"
          class="el-button el-button--default cancle normal_btn">取消</button>
        <button type="button" @click="editSubmit()"
          class="el-button el-button--default search_btn normal_btn">保存</button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import {
  keywordconfig, keywordconfiginsert, keywordconfigupdate, keywordconfigdel, keywordconfiggetinfo
} from "../../api/shopWindow";

export default {
  name: "ringcontentkeyword",//录音识别配置
  mixins: [alertTrends],
  data() {
    return {
      configid: "",
      show3: true, // 查询区域默认展开
      isToExamine: false, // 品牌管理弹框
      dataList: [], // 查询列表
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      

      jsName: "", // 搜索关键字
      caozuo: '',
      caozuoarr: [
        {
          Id: -1,
          label: "全部"
        }, 
        {
          Id: 0,
          label: "通用"
        },
        {
          Id: 1,
          label: "客源大厅"
        },
        {
          Id: 2,
          label: "店铺客户"
        },
        {
          Id: 3,
          label: "店铺电话"
        },
      ],
      addeditsee: '', //新增or编辑
      form: {
        businessType: '', // 业务类型
        configType: '', // 新增：配置类型（1-5）
        checkValue: '', // 新增：校验值（仅配置类型1/2显示）
        keyword: '', // 关键字
        level: '', // 权重分值
        remark: '' // 备注
      },
      configtype: 0,
      configtypeArr: [
        { Id: 0, label: "全部" },
        { Id: 1, label: "校验分值" },
        { Id: 2, label: "通话时长" },
        { Id: 3, label: "品牌" },
        { Id: 4, label: "品类" },
        { Id: 5, label: "自定义" }
      ],
    }
  },
  methods: {
    

    //查询列表
    init() {
      let addParams = {
        businesstype: this.caozuo||0, // 业务类型 0=全部 1=客源大厅 2=店铺客户 3=店铺电话
        configtype: this.configtype,
        keyword: this.jsName,
        page: this.pageIndex,// 分页数据 当前页码
        size: this.pageSize // 分页数据 每页显示条数
      };
      keywordconfig(addParams).then(data => {
        this.dataList = data.resultObj.list;
        this.total = data.resultObj.totalcount;
      })
      .catch(err => {
        this.dataList = [];
      });
    },

    
    // 重置
    fnReset() {
      this.jsName = '';
      this.caozuo = '';
      this.configtype = 0;
      this.pageIndex == 1
      this.init();
    },

    handleNumberInput(field) {
      let value = this.form[field].toString().replace(/[^\d]/g, '');
      // 限制最大值100
      if (parseFloat(value) > 100) {
        value = '100';
      }
      // 处理前导0
      if (value !== '' && value !== '0') {
        value = value.replace(/^0+/, '');
        if (value === '') {
          value = '0';
        }
      }
      this.form[field] = value;
    },

    handleLevelInput() {
      this.handleNumberInput('level');
    },
    handleLevelInputa() {
      this.handleNumberInput('checkValue');
    },


    // // 新增：处理权重分值输入
    // handleLevelInput() {
    //   // 正则匹配：只能输入0-100的数字（包括整数和小数）
    //   // 先移除非数字和非小数点的字符
    //   this.form.level = this.form.level.toString().replace(/[^\d]/g, '');
    //   // // 去掉开头的小数点
    //   // this.form.level = this.form.level.replace(/^\./g, '');
    //   // 限制最大值为100
    //   if (parseFloat(this.form.level) > 100) {
    //     this.form.level = '100';
    //   }
    //   // 去掉开头的0（特殊处理0和0.xx的情况）
    //   if (this.form.level !== '' && this.form.level !== '0' && this.form.level !== '0.') {
    //     this.form.level = this.form.level.replace(/^0+/, '');
    //     // 如果处理后为空（如原先是000），则设置为0
    //     if (this.form.level === '' || this.form.level === '.') {
    //       this.form.level = '0';
    //     }
    //   }
    // },
    // // 新增：处理校验值输入
    // handleLevelInputa() {
    //   // 正则匹配：只能输入0-100的数字（包括整数和小数）
    //   // 先移除非数字和非小数点的字符
    //   this.form.checkValue = this.form.checkValue.toString().replace(/[^\d]/g, '');
    //   // // 去掉开头的小数点
    //   // this.form.checkValue = this.form.checkValue.replace(/^\./g, '');
    //   // 限制最大值为100
    //   if (parseFloat(this.form.checkValue) > 100) {
    //     this.form.checkValue = '100';
    //   }
    //   // 去掉开头的0（特殊处理0和0.xx的情况）
    //   if (this.form.checkValue !== '' && this.form.checkValue !== '0' && this.form.checkValue !== '0.') {
    //     this.form.checkValue = this.form.checkValue.replace(/^0+/, '');
    //     // 如果处理后为空（如原先是000），则设置为0
    //     if (this.form.checkValue === '' || this.form.checkValue === '.') {
    //       this.form.checkValue = '0';
    //     }
    //   }
    // },

    // 新增：配置类型变化时触发
    handleConfigTypeChange() {
      // 规则：若配置类型≠5，关键字置空且禁用
      if (this.form.configType !== 5) {
        this.form.keyword = ''; // 置空关键字
      }
      // 若配置类型≠1/2，清空校验值（避免残留）
      if (![1, 2].includes(this.form.configType)) {
        this.form.checkValue = '';
      }
    },
    
    // 根据businesstype获取对应的label
    getBusinessTypeLabel(businesstype) {
      // 查找caozuoarr中Id与businesstype匹配的项
      const matchedItem = this.caozuoarr.find(item => item.Id === businesstype);
      // 若找到则返回label，否则返回空字符串或默认值
      return matchedItem ? matchedItem.label : '';
    },
    // 触发 编辑按钮 & 新增按钮 是否回显
    addOrEditBrand(row) {
      // 重置表单
      this.$refs.form && this.$refs.form.resetFields();
      // 如果有数据就是编辑 否则就是新增
      if (row) {
        this.addeditsee = "编辑";
        this.configid = row.configid;
        keywordconfiggetinfo({}, row.configid).then(data => {
          if (data.resultCode == 1) {
            // 回显数据
            let seeArr = data.resultObj;
            // const matchedItem = this.configtypeArr.find(item => item.Id === seeArr.keyword);
            this.form = {
              businessType: this.getBusinessTypeLabel(seeArr.businesstype),
              configType: seeArr.configtype, // 新增：回显配置类型（接口返回的configtype字段）
              keyword: seeArr.keyword, // 原有：关键字
              level: seeArr.score, // 原有：权重分值
              remark: seeArr.remark, // 原有：备注
              checkValue: seeArr.value // 新增：回显校验值
            };
            console.log(seeArr, this.form)
            // 触发配置类型变化事件，确保条件控制生效（如关键字禁用、校验值显示）
            this.handleConfigTypeChange();
          }
        })

        
      } else {
        this.addeditsee = "新增";
        this.configid = '';
        // 清空表单
        this.form = {
          businessType: '',
          configType: '', // 新增：清空配置类型
          keyword: '',
          level: '',
          remark: '',
          checkValue: '' // 新增：清空校验值
        };
      }
      this.isToExamine = true; // 品牌管理详情弹框展示
    },
    //删除
    deleteBrand(row){
      this.$swal({
        type: "warning",
        text: "重要信息，你确定要删除当前数据吗？",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          var loginParams = {
            configid: row.configid, // 配置ID
          };
          keywordconfigdel(loginParams).then(data => {
            if (data.resultCode == 1) {
              this.showAlert('删除成功', 'success');
              this.init();
            }
          })
        }
      });
    },
    // 保存按钮
    editSubmit() {
      if (this.form.businessType==='') {
        this.showAlert('请选择业务类型'); // 调用mixins中的提示方法
        return; // 终止后续操作
      }
      if (!this.form.configType) {
        this.showAlert('请选择配置类型');
        return;
      }
      if (this.form.configType == 1 || this.form.configType == 2) {
        // 校验3：权重分值必须选择
        if (!this.form.checkValue) {
          this.showAlert('请输入校验值');
          return;
        }
        if (isNaN(Number(this.form.checkValue))) {
          this.showAlert('校验值必须为数字');
          return;
        }
        // 子校验3：校验值不能为负数
        if (Number(this.form.checkValue) < 0) {
          this.showAlert('校验值不能为负数');
          return;
        }
      }
      if (this.form.configType === 5) {
        if (!this.form.keyword.trim()) { // 去除空格后判断（避免输入纯空格）
          this.showAlert('请输入关键字');
          return;
        }
      } 
      if (this.form.level === '' || isNaN(Number(this.form.level))) {
        this.showAlert('请输入有效的权重分值');
        return;
      }
      const level = Number(this.form.level);
      if (level < 0 || level > 100) {
        this.showAlert('权重分值必须在0-100之间');
        return;
      }

      // 判断是编辑还是新增
      if (this.configid) {  //编辑
        let keywordNew = this.configtypeArr.find(item => item.Id == this.form.configType).label;
        var loginParams = {
          configid: this.configid, // 配置ID
          keyword: this.form.configType == 5 ? this.form.keyword : keywordNew,
          value: this.form.checkValue||0,//校验值
          score: Number(this.form.level), //级别 1-10级
          remark: this.form.remark,
        };
        keywordconfigupdate(loginParams).then(data => {
          if (data.resultCode == 1) {
            this.showAlert('编辑成功', 'success');
            this.isToExamine = false;
            this.init();
          }
        })
          .catch(err => {
            console.log(err);
          });
      } else { //新增
        let keywordNew = this.configtypeArr.find(item => item.Id == this.form.configType).label;
        var loginParams = {
          businesstype: this.form.businessType,
          configtype: this.form.configType,
          value: this.form.checkValue,
          keyword: this.form.configType==5?this.form.keyword: keywordNew,
          score: Number(this.form.level),
          remark: this.form.remark,
        };
        keywordconfiginsert(loginParams).then(data => {
          if (data.resultCode == 1) {
            this.showAlert('新增成功', 'success');
            this.isToExamine = false;
            this.init();
          }
        })
          .catch(err => {
            console.log(err);
          });
      }
    },
    // 查询
    onSubmit() {
      this.pageIndex = 1;
      this.init();
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    }
  },
  created() {
  },
  mounted(){
    this.init();
  },
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// ringcontentkeyword.vue?0056e515